export default [
  {
    label: 'Service Item Type Maintenance',
    value: 'ServiceItemTypeDetail',
  },
];
